// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: 9
    /* Optional */
    // loadProductFirst: true,
  }
};

// Declare Templates
var bcSfFilterTemplate = {
  soldOutClass: "sold-out",
  saleClass: "on-sale",
  soldOutLabelHtml: "<div>" + bcSfFilterConfig.label.sold_out + "</div>",
  saleLabelHtml:
    '<div class="coll-sale"><div>' +
    bcSfFilterConfig.label.sale +
    "</div></div>",
  vendorHtml: "<div>{{itemVendorLabel}}</div>",

  // Grid Template
  productGridItemHtml:
    '<div class="coll-card" data-sn="{{itemStyle}}">' +
    "{{itemSaleLabel}}" +
    '<div class="coll-img">' +
    '<a href="{{itemUrl}}">' +
    '<img class="lazyload" data-src="{{itemThumbUrl}}" alt="">' +
    "</a>" +
    '<div class="quick-add">' +
    "<p>Quick add</p>" +
    "<ul class='size-selection'>" +
    "</ul>" +
    "<ul class='color-selection'>" +
    "{{itemColor}}" +
    "</ul>" +
    "</div>" +
    "</div>" +
    '<div class="coll-desc">' +
    '<div class="coll-brand">' +
    "<p>{{itemVendor}}</p>" +
    "</div>" +
    '<div class="coll-title">' +
    "<p>{{itemTitle}}</p>" +
    "</div>" +
    "</div>" +
    '<div class="coll-price">' +
    "{{itemPrice}}" +
    "</div>" +
    '<div class="coll-swatches">' +
    "<ul>" +
    "{{colorMobile}}" +
    "</ul>" +
    "</div>" +
    "</div>",

  // Pagination Template
  previousActiveHtml: '<li><a href="{{itemUrl}}">&lsaquo;</a></li>',
  previousDisabledHtml: '<li class="disabled"><span>&lsaquo;</span></li>',
  nextActiveHtml: '<li><a href="{{itemUrl}}">&rsaquo;</a></li>',
  nextDisabledHtml: '<li class="disabled"><span>&rsaquo;</span></li>',
  pageItemHtml: '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  pageItemSelectedHtml: '<li><span class="active">{{itemTitle}}</span></li>',
  pageItemRemainHtml: "<li><span>{{itemTitle}}</span></li>",
  paginateHtml:
    '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

  // Sorting Template
  sortingHtml:
    '<label for="bc-sf-filter-top-sorting-select" class="label--hidden">' +
    bcSfFilterConfig.label.sorting +
    '</label><select id="bc-sf-filter-top-sorting-select" class="collection-sort__input">{{sortingItems}}</select>'
};

/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  /*** Prepare data ***/
  var images = data.images_info;
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data["variants"][0];
  if (getParam("variant") !== null && getParam("variant") != "") {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam("variant");
    });
    if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data["variants"].length; i++) {
      if (data["variants"][i].available) {
        firstVariant = data["variants"][i];
        break;
      }
    }
  }
  // Displaying price base on the policy of Shopify, have to multiple by 100
  (data.price_min *= 100),
    (data.price_max *= 100),
    (data.compare_at_price_min *= 100),
    (data.compare_at_price_max *= 100);
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;

  // Add Thumbnail
  var itemThumbUrl =
    images.length > 0
      ? this.optimizeImage(images[0]["src"])
      : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

  // ADD PRICE
  var itemPriceHtml = "";
  var priceDisc = Math.round(
    100 - (data.price_min / data.compare_at_price_min) * 100
  );
  if (data.title != "") {
    if (onSale) {
      itemPriceHtml =
        '<p class="coll-disc">' +
        this.formatMoney(data.compare_at_price_min) +
        "</p>";
    }
    if (priceVaries) {
      if (bcSfFilterConfig.label.from_price != undefined) {
        itemPriceHtml += bcSfFilterConfig.label.from_price.replace(
          /{{ price }}/g,
          this.formatMoney(data.price_min)
        );
      } else {
        itemPriceHtml = this.formatMoney(data.price_min);
      }
    } else {
      itemPriceHtml += "<p>" + this.formatMoney(data.price_min) + "</p>";
    }
  }

  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

  // ADD SIZE VARIANTS
  var itemSizeHtml = "";
  var sizeVar = data.variants;
  $.map(sizeVar, function(value, index) {
    if (value.option_size != undefined) {
      if (value.inventory_quantity > 0) {
        itemSizeHtml +=
          '<li><a href="javascript:void(0)" class="size-opt" data-id="' +
          value.id +
          '" data-qty="' +
          value.inventory_quantity +
          '">' +
          value.option_size +
          "</a></li>";
      } else {
        itemSizeHtml +=
          '<li class="unavailable" disabled="disabled"><a href="javascript:void(0)" class="size-opt" data-id="' +
          value.id +
          '" data-qty="' +
          value.inventory_quantity +
          '">' +
          value.option_size +
          "</a></li>";
      }
    } else {
      if (value.inventory_quantity > 0) {
        itemSizeHtml +=
          '<button class="size-opt" data-id="' +
          value.id +
          '">Add to Cart</button>';
      } else {
        itemSizeHtml +=
          '<button class="size-opt" data-id="' +
          value.id +
          '" disabled="disabled">Add to Cart</button>';
      }
    }
  });
  //Simple-COmplex
  var bcsffilterdata = data,
      
      swatch_html = '',
      
      swatch_mobile = '';
  
  

//     $.ajax({
//       url: `https://${window.location.hostname}/search?view=json&q="${bcsffilterdata.title}`,
//       method: "GET",
//   	  async: false,
//       success: function(response) {
//           var results = JSON.parse(response).results
//           results.map(result => {          
//             if(result.title === bcsffilterdata.title) {
//               var swatch = result.swatch,
//                   variants = bcsffilterdata.variants,
//                   selected_variant = Array.from(new Set(result.variants.filter(variant => { return variant.option1 === result.color }))),
//                   colors = Array.from(new Set(selected_variant.map(variant => { return variant.option1 })));
//             colors.map(color => {
//               var attr_data = selected_variant.map(variant => { if(variant.option1 === color) { return [variant.option2, variant.id, variant.available] }  }).filter(item => { return item !== undefined });
//               swatch_html += `<li class="col_swatch_list">
//                             <button class="js-swatch-selection col-swatch-btn" data-arr='${JSON.stringify(attr_data)}'>
//                               <img style="background-color: ${color}" src="${swatch}" class="pr_selection_swatch">
//                             </button>
//                           </li>`;
//               swatch_mobile += `<li class="col_swatch_list no-desk">
// 							<a class="col-swatch-btn" href="${result.url}" data-arr='${JSON.stringify(attr_data)}'>
//                               <img style="background-color: ${color}" src="${swatch}" class="pr_selection_swatch">
//                             </a>
//                           </li>`;
//             })
//             }

//           })
          
//       },
//       error: function(data) {}
//     });
  

//   //Complex
//   var variants = data.variants,
//       colors = Array.from(new Set(variants.map(variant => { return variant.option_color })));
//   colors.map(color => {
//     var ftxt = 'files/?',
//         swatch = `${bcsffilter.fileUrl.slice(0, bcsffilter.fileUrl.indexOf(ftxt) + ftxt.length - 1)}color-${(color).toLowerCase()}.png`,
//         attr_data = variants.map(variant => { if(variant.option_color === color) { return [variant.option_size, variant.id, variant.available] }  }).filter(item => { return item !== undefined });
//     	swatch_html += `<li class="col_swatch_list">
// 						  <button class="js-swatch-selection col-swatch-btn" data-arr='${JSON.stringify(attr_data)}'>
//                           	<img style="background-color: ${color}" src="${swatch}" class="pr_selection_swatch">
//                           </button>
// 						</li>`;
//   })

  
  //   ADD COLOR VARIANT
  var pr_title = data.title,
    dHandle = data.handle,
    name = pr_title.toLowerCase().replace(/ /g, "-"),
    codeIndex = name.length + 1,
    code = dHandle.substring(codeIndex, codeIndex + 7),
    colorDiv = $('#swatch-repo .col_swatch_list.desktop[data-title="' + data.title + '"]'),
    mobColorDiv = $('#swatch-repo .col_swatch_list.mobile[data-title="' + data.title + '"]');
  var productcolors = "";
  colorDiv.each(function(index, color) {
    var $this = $(this);
    if(data.title == $this.data('title')) {
      swatch_html += $this[0].outerHTML
    }
  });
  mobColorDiv.each(function(index, color) {
    var $this = $(this);
    if(data.title == $this.data('title')) {
      swatch_mobile += $this[0].outerHTML
    }
  });
  
  itemHtml = itemHtml.replace(/{{itemColor}}/g, swatch_html);
  itemHtml = itemHtml.replace(/{{colorMobile}}/g, swatch_mobile)
  itemHtml = itemHtml.replace(/{{itemSize}}/g, itemSizeHtml);


  itemHtml = itemHtml.replace(/{{itemColors}}/g, productcolors);
  itemHtml = itemHtml.replace(/{{itemStyle}}/g, pr_title);

  //  PRODUCT VARIANT ID
  var productId = data.variants[0].id;
  itemHtml = itemHtml.replace(/{{productId}}/g, productId);

  // PRODUCT URL
  var productUrl = `/products/${data.handle}`;
  itemHtml = itemHtml.replace(/{{productUrl}}/g, productUrl);

  // PRODUCT QUANTITY
  var productQty = data.variants[0].inventory_quantity;
  itemHtml = itemHtml.replace(/{{productQty}}/g, productQty);

  // PRODUCT PRICE WITHOUT CURRENCY
  var productPrice = data.price_min / 100;
  itemHtml = itemHtml.replace(/{{productPrice}}/g, productPrice);

  // PRODUCT MASTER ID
  var productMasterId = data.id;
  itemHtml = itemHtml.replace(/{{productMasterId}}/g, productMasterId);

  // Add soldOut class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : "";
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

  // Add onSale class
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : "";
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

  // Add soldOut Label
  var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : "";
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

  // Add onSale Label
  var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : "";
  itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

  // Add Vendor
  var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable
    ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor)
    : "";
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  // // Add Description
  // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  // // Truncate by word
  // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
  // // Truncate by character
  // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
  // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
  for (var k in data) {
    // Add Options
    var optionsArr = [];
    for (var i in data[k]["options_with_values"]) {
      optionsArr.push(data[k]["options_with_values"][i]["name"]);
    }
    data[k]["options"] = optionsArr;

    // Customize variants
    for (var i in data[k]["variants"]) {
      var variantOptionArr = [];
      var count = 1;
      var variant = data[k]["variants"][i];
      // Add Options
      var variantOptions = variant["merged_options"];
      if (Array.isArray(variantOptions)) {
        for (var j = 0; j < variantOptions.length; j++) {
          var temp = variantOptions[j].split(":");
          data[k]["variants"][i]["option" + (parseInt(j) + 1)] = temp[1];
          data[k]["variants"][i]["option_" + temp[0]] = temp[1];
          variantOptionArr.push(temp[1]);
        }
        data[k]["variants"][i]["options"] = variantOptionArr;
      }
      data[k]["variants"][i]["compare_at_price"] =
        parseFloat(data[k]["variants"][i]["compare_at_price"]) * 100;
      data[k]["variants"][i]["price"] =
        parseFloat(data[k]["variants"][i]["price"]) * 100;
    }

    // Add Description
    data[k]["description"] = data[k]["body_html"];
  }
  return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  if (this.getSettingValue("general.paginationType") == "default") {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
      jQ(this.selector.bottomPagination).html("");
      return false;
    }

    if (this.getSettingValue("general.paginationType") == "default") {
      var paginationHtml = bcSfFilterTemplate.paginateHtml;

      // Build Previous
      var previousHtml =
        currentPage > 1
          ? bcSfFilterTemplate.previousActiveHtml
          : bcSfFilterTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        this.buildToolbarLink("page", currentPage, currentPage - 1)
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml =
        currentPage < totalPage
          ? bcSfFilterTemplate.nextActiveHtml
          : bcSfFilterTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        this.buildToolbarLink("page", currentPage, currentPage + 1)
      );
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...");
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...");
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = "";
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == "...") {
          pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? bcSfFilterTemplate.pageItemSelectedHtml
              : bcSfFilterTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          this.buildToolbarLink("page", currentPage, pageArr[iPage])
        );
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

      jQ(this.selector.bottomPagination).html(paginationHtml);
    }
  }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterTemplate.hasOwnProperty("sortingHtml")) {
    jQ(this.selector.topSorting).html("");

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = "";
      for (var k in sortingArr) {
        sortingItemsHtml +=
          '<option value="' + k + '">' + sortingArr[k] + "</option>";
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(
        /{{sortingItems}}/g,
        sortingItemsHtml
      );
      jQ(this.selector.topSorting).html(html);

      // Set current value
      jQ(this.selector.topSorting + " select").val(this.queryParams.sort);
    }
  }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  if (!$(".bc-sf-filter-block-title span").hasClass("up")) {
    $(".bc-sf-filter-block-title span").trigger("click");
  }

  console.log(data);
  
  var product_impression = [];
  
  var products = data.products
  if (products.length > 0) {
    products.forEach((item, i) => {
      if(item.available) {
        product_impression.push({
         name: item.title,
         id: item.id.toString(),
         price: (item.price || item.price_min_php).toString(),
         brand: item.vendor,
         category: item.product_type,
         variant: item.variants.find(variant => variant.available).title,
         list: bcSfFilterMainConfig.general.template === "collection" ? bcSfFilterMainConfig.general.collection_title : bcSfFilterMainConfig.general.template,
         position: i
       })
      }
    })
    // Push product impression event
    if(product_impression.length > 0) {
      dataLayer.push({ ecommerce: null }); //Clear previous object
      dataLayer.push({
        'ecommerce': {
          'currencyCode': Shopify.currency.active,
          'impressions': product_impression
        }
      });
    }
  }
  
  //   ADD BUTTON
  $(".size-opt").click(function(e) {
    e.preventDefault();
    var $this = $(this),
      pid = parseInt($this.data("id"));
    var $panel = $("#pl-cart-popup");
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: pid
      },
      dataType: "json",
      success: function(cart) {
        console.log(cart)
        $panel.addClass("cart-opened");
        $("#pl-cart-popup").load(document.URL + " #pl-cart-popup>*");
      },
      error: function(error) {
        alert(error.responseJSON.description);
      }
    });
  });

  // SIMPLE COMPLEX
  var pr_g = $(".coll-card"),
    c = $("#sort-total-products"),
    d = $("#sort-total-products-mob");
  for (var h = 0; h < pr_g.length; h++) {
    var v = pr_g.eq(h).data("sn"),
      s = $.trim(v);
    k = $('.coll-card[data-sn="' + v + '"]');
    for (n = 0; n < k.length; n++) {
      if (n > 0) {
        k.eq(n).remove();
      }
    }
  }
  //   c.text($('.coll-card').length + ' Results');
  //   d.text($('.coll-card').length + ' Results');

  // MOBILE FILTER BUTTON
  $("#bc-sf-filter-tree-mobile button").click(function(e) {
    $(".mob-filter").css("height", "100%");
    e.stopPropagation();
  });
  // MOBILE FILTER
  if ($(window).width() <= 767) {
    $("#bc-sf-filter-tree").appendTo(".mob-filter .mob-filter-main");
  }
  // CLOSE BUTTON
  $(".close-icon button").click(function(e) {
    $(".mob-filter").css("height", "0");
    $("#bc-sf-filter-tree").removeClass("bc-sf-filter-tree-mobile-open");
    $("#bc-sf-filter-tree").css("display", "none");
    e.stopPropagation();
  });

  // WISHLIST
  function loadSwat() {
    if(window._swat) {
        console.log('Loaded')
      window._swat.fetch(function(r) {
        console.log(r)
        for (i = 0; i < r.length; i++) {
          var x = r[i].epi;
          wishListIcon = $(".coll-card")
          .find('.heart-img[data-id="' + x + '"]')
          .addClass("shade");
        }
      });
    }else {
      setTimeout(function() {
        console.log('Not loaded')
        loadSwat()
      }, 1000)
    }
  }

  $(".sort-cta").text($("#bc-sf-filter-top-sorting option:selected").text());
  $("#bc-sf-filter-top-sorting").change(function() {
    var $this = $(this);
    $(".sort-cta").text($this.find("option:selected").text());
  });
  $(".sort-cta").click(function() {});
  
  
  $('.js-swatch-selection').click(function(e) {
    e.preventDefault();
    var $this = $(this),
        arr = $this.data('arr'),
        li = $this.parent(),
        size_cont = li.parent().prev(),
        html = '';
    
    arr.map(item => {
      if(item[1] !== undefined || item[1] !== null) {
      html += `<li ${!item[2] ? 'disabled' : '' }>
					<a href="javascript:void(0)" class="size-opt" data-id="${item[1]}" data-qty="1" onclick="cartDrawer.addItem({'quantity': ${1}, 'id': ${parseInt(item[1])}})" ${!item[2] ? 'disabled' : '' }>${item[0]}</a>
				  </li>`
      }
      
    })
    li.addClass('active').siblings().removeClass('active')
    size_cont.html(html)
  })
  
  function sideFilterStickyFunction() {
    var filterContainer = $('.filter-cont'),
        objPosition = $('#main-container-fluid').offset(),
        navHeight = $('.js-nav-anim').height(),
        currentYPosition = navHeight + window.scrollY,
        footerContainer = $('footer.footer-section'),
        footerObjPosition = footerContainer.offset(),
        filterContainerOffsetBottom = window.scrollY + filterContainer.height();

    if(currentYPosition >= objPosition.top && filterContainerOffsetBottom < footerObjPosition.top) {
      filterContainer.addClass('sticky-side-filter')
    }else if(currentYPosition < objPosition.top || filterContainerOffsetBottom >= footerObjPosition.top) {
      filterContainer.removeClass('sticky-side-filter')
    }
  }
  $(document).scroll(sideFilterStickyFunction)
};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
